export const SMART_CONTEXTS_COLLECTION_ID = "tanstack-smart-contexts";
